import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { fromDebugFlags } from '../reducers';
import { DebugFlagSettings } from '../config';

export const getDebugFlagsState: MemoizedSelector<
  object,
  fromDebugFlags.State
> = createFeatureSelector<fromDebugFlags.State>('debugFlags');

/**
 * Selector to return the current settings for the Debug Flags
 */
export const getDebugFlagSettings: MemoizedSelector<object, DebugFlagSettings> = createSelector(
  getDebugFlagsState,
  state => state && state.settings
);

/**
 * Selector to return the the Debug Flags are loaded
 */
export const getDebugFlagsLoaded: MemoizedSelector<object, boolean> = createSelector(
  getDebugFlagsState,
  state => state && state.isLoaded
);
